import React from 'react';
import {useEffect, useState} from 'react';
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom';
import { API } from 'aws-amplify';
import { Storage } from 'aws-amplify';

import AlertModal from '../../AlertModal'
import MissingIcon from '../../../images/missing.jpg';
import DropdownSort from '../../../components/DropdownSort'
import LiveCampaignsSidebar from '../../dashboard/live-campaigns/LiveCampaignsSidebar'
import LiveCampaignItem from '../../dashboard/live-campaigns/LiveCampaignItem'
import LiveCampaignStatCard from '../../dashboard/live-campaigns/LiveCampaignStatCard'


import { getDatabase, ref as databaseRef, onChildAdded, query, orderByChild,
  limitToLast, get, child, limitToFirst, off, equalTo, onValue } from "firebase/database";
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";


function LiveCampaignsContent({updateContentState, setAlertModalState, authToken}) {

  const [notificationList, setNotificationList] = useState([])
  const storage = getStorage();

  const [audienceFilter, setAudienceFilter] = useState(null)
  const [brandSizeFilter, setBrandSizeFilter] = useState(null)
  const [notiRef, setNotiRef] = useState(null)
  const [metaAudience, setMetaAudience] = useState({})
  const [metaBrandSize, setMetaBrandSize] = useState({})
  const [notiFilter, setNotiFilter] = useState({'audience': [], 'brandSize': []})
  const [ textFilter, setTextFilter ] = useState('')
  const [sorter, setSorter] = useState('Newest')

  const [ brandCount, setBrandCount ] = useState(-1)
  const [ campaignCount, setCampaignCount ] = useState(-1)
  const [ marketCount, setMarketCount ] = useState(-1)

  const [loadingVisible, setLoadingVisible] = useState(false);

  useEffect(() => {
    fetchAppMeta()
    fetchCampaignStats()
  }, [authToken]);

  useEffect(() => {
    fetchLiveEmulatorData()
  }, [sorter, notiFilter]);

  function timestampToTime(timestamp){
    var milliseconds = parseInt(timestamp)
    const dateObject = new Date(milliseconds)
    return dateObject.toLocaleString("en-IE")
  }

  function updateSorter(val){
    setSorter(val)
  }

  function updateFilter(val){
    document.getElementById('noti-search').value = ''
    setNotiFilter(val)
  }

  function timeSince(timestamp) {
    var milliseconds = parseInt(timestamp)
    const dateObject = new Date(milliseconds)
    var seconds = Math.floor((new Date() - dateObject) / 1000);
    if(seconds<0)
      seconds = 0

    var interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " mins ago";
    }
    return Math.floor(seconds) + " secs ago";
  }

  function cleanTitle(n){
    if(n.title!='' && n.title!=undefined && n.title!='unknown')
      return n.title
    if(n.extraTitle!='' && n.extraTitle!=undefined && n.extraTitle!='unknown')
      return n.extraTitle
    return 'New message from '+n.appName
  }

  function inBlacklist(n){
    if(n.extraText.includes('Tap for more information') ||
      n.extraTitle.includes('Syncing content') ||
      n.extraText.includes('Still want this') ||
      n.extraText.includes('Sync started') ||
      n.extraText.includes('Updating...')||
      n.extraText.includes('Preparing...')||
      n.extraText.includes('empushy')
    )
      return true
    if((n.title!=undefined && n.title=='Profile updated')||(n.extraText=='unknown'))
      return true
    if((n.title==''|| n.title==undefined) && (n.extraTitle==''||n.extraTitle==undefined) && (n.extraText==''||n.extraText==undefined))
      return true
    if(n.appName=='Google Play Store' || n.appName=='Download Manager' || n.appName=='Gmail' ||
      n.appName=='Android Setup' || n.appName=='Android Setup' || n.appName=='Android System' || n.appName=='Google Play services'||
      n.appName=='Signal')
      return true
    return false
  }

  function cleanDownloads(downloads){
    if(downloads != null) {
      downloads = downloads.toString()
      downloads = downloads.replace('+', '').replace(',', '')
      if (downloads != 'unknown' && downloads.includes('M') && downloads.includes('.'))
        downloads = downloads.split('.')[0] + downloads.split('.')[1][0] + '00000'
      if (downloads != 'unknown' && downloads.includes('M'))
        downloads = downloads.replace('M', '') + '000000'
      if (downloads != 'unknown' && downloads.includes('k') && downloads.includes('.'))
        downloads = downloads.split('.')[0] + downloads.split('.')[1][0] + '00'
      if (downloads != 'unknown' && downloads.includes('k'))
        downloads = downloads.replace('k', '') + '000'

      downloads = parseInt(downloads)
      if (downloads <= 1000)
        return 'smallest (<1k)'
      else if (downloads <= 10000)
        return 'small (1k-10k)'
      else if (downloads <= 100000)
        return 'medium (10k-100k)'
      else if (downloads <= 500000)
        return 'large (100k-500k)'
      else
        return 'largest (500k+)'
    }
    return 'unknown'
  }

  function fetchAppMeta(){
    const dbRef = databaseRef(getDatabase());

    get(child(dbRef, "web/installed_apps")).then((snapshot) => {
      if (snapshot.exists()) {
        var audiences = {}
        var brandSizes = {}
        snapshot.forEach(function (snap) {
          var app = snap.val()
          app.downloads = cleanDownloads(app.downloads)
          if(audiences.hasOwnProperty(app.type))
            audiences[app.type].push(app.appPackage)
          else {
            audiences[app.type] = [app.appPackage]
          }
          if(brandSizes.hasOwnProperty(app.downloads))
            brandSizes[app.downloads].push(app.appPackage)
          else {
            brandSizes[app.downloads] = [app.appPackage]
          }
        })
        setMetaAudience(audiences)
        setMetaBrandSize(brandSizes)
      } else {
        console.log("No data available");
      }
      fetchLiveEmulatorData()
    }).catch((error) => {
      console.error(error);
    });
  }

  async function textFilterChange(event){
    console.log(notiFilter)
    if(event!==undefined && event!==null)
      event.preventDefault();
    var text = document.getElementById('noti-search').value

    if(text!=null && text.trim()!=='' && text.trim().split(' ') && authToken!=null){
      setLoadingVisible(true)
      if(notiRef!=null){
        off(notiRef, "child_added")
      }
      console.log(notiFilter['audience'].join(','))
      setNotificationList([])
      const apiName = 'DashboardAPI';
      const path = '/emulator/query';
      const params = {
        queryStringParameters: {
          case: 'live-campaign-search',
          text: text,
          types: notiFilter['audience'].join(','),
          sizes: notiFilter['brandSize'].join(',')
        },
        headers: {
          Authorization: `Bearer ${authToken}`
        },
      };

      API
        .get(apiName, path, params)
        .then(async(response) => {
          setLoadingVisible(false)
          if('notifications' in response){
            var notifications = []
            for(var n of response['notifications']){
              n['extraText'] = n.extratext
              n['appName'] = n.appname
              try {
                n['icon'] = await getDownloadURL(storageRef(storage, n.app + '.jpg'))
              } catch (e){
                n['icon'] = MissingIcon
              }
              n['title'] = cleanTitle(n)
              n['date'] = timeSince(n.id)

              notifications.push(n)
              notifications.sort(function (a, b) {
                return b.id > a.id ? 1 : -1
              })
            }
            setNotificationList(notifications.map((item) => {
              return (
                <LiveCampaignItem
                  key={item.id}
                  id={item.id}
                  image={item.icon}
                  app={item.appName}
                  link={item.id}
                  title={item.title}
                  text={item.extraText}
                  date={item.date}
                  type={item.appName}
                  fav={item.id}
                />
              );
            }))
          }
          else{
            console.log('No notifications.')
          }
        })
        .catch(error => {
          setLoadingVisible(false)
          console.log('Error executing request.')
          console.log(error)
        });
    }
    return false
  }

  async function fetchLiveEmulatorData(){
    console.log(notiFilter)
    console.log(sorter)
    if(notiRef!=null){
      off(notiRef, "child_added")
    }

    var filters = 0
    var textFilter = false
    for(var key of Object.keys(notiFilter)) {
      filters += notiFilter[key].length
      if(key==='text')
        textFilter = true
    }
    var notifications = []
    setNotificationList([])

    if(filters===0 && !textFilter) {
      setLoadingVisible(true)
      var reference = databaseRef(getDatabase(), 'archive/fBH3JoQDjZegNio4gYH99hTDS872')
      var notiQuery = query(reference, sorter === 'Newest' ? limitToLast(50) : limitToFirst(100),
        orderByChild('id'))
      onChildAdded(notiQuery, (snapshot) => {
        var n = snapshot.val()
        if (!inBlacklist(n)) {
          var url = getDownloadURL(storageRef(storage, n.app + '.jpg')).then((url) => {
            n['icon'] = url
            n['title'] = cleanTitle(n)
            n['date'] = timeSince(n.id)

            notifications.push(n)
            notifications.sort(function (a, b) {
              return b.id > a.id ? 1 : -1
            })
            setNotificationList(notifications.map((item) => {
              return (
                <LiveCampaignItem
                  key={item.id}
                  id={item.id}
                  image={item.icon}
                  app={item.appName}
                  link={item.id}
                  title={item.title}
                  text={item.extraText}
                  date={item.date}
                  type={item.appName}
                  fav={item.id}
                />
              );
            }))

          }).catch((error) => {
            n['icon'] = MissingIcon
            n['title'] = cleanTitle(n)
            n['date'] = timeSince(n.id)

            notifications.push(n)
            notifications.sort(function (a, b) {
              return b.id > a.id ? 1 : -1
            })
            setNotificationList(notifications.map((item) => {
              return (
                <LiveCampaignItem
                  key={item.id}
                  id={item.id}
                  image={item.icon}
                  app={item.appName}
                  link={item.id}
                  title={item.title}
                  text={item.extraText}
                  date={item.date}
                  type={item.appName}
                  fav={item.id}
                />
              );
            }))
          });
        }
        setLoadingVisible(false)
      })
      setNotiRef(reference)
    }
    else if(filters>0 && !textFilter) {
      setLoadingVisible(true)
      /* Filter not null */
      // assume filter is  of {audience: [selectedvals..], brandSize: [selectedvals..]}
      var apps = []
      for(var audience of notiFilter['audience']){
        apps = apps.concat(metaAudience[audience])
      }
      for(var size of notiFilter['brandSize']){
        if(apps.length>0)
          apps = apps.filter(value => metaBrandSize[size].includes(value));
        else
          apps = apps.concat(metaBrandSize[size])
      }
      fetchFilteredData(apps, sorter)
      setNotificationList('')
    }
    else{
      /* Text filter.. send to server */
      console.log(notiFilter)
    }
  }

  async function fetchCampaignStats(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'live-campaign-stats'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {
          if('stats' in response){
            setBrandCount(response['stats']['brandcount'][0])
            setCampaignCount(response['stats']['campaigncount'][0])
            setMarketCount(response['stats']['marketcount'][0])
          }
          else{
            console.log('Stats data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  async function fetchFilteredData(apps, sorter){
    var reference = databaseRef(getDatabase(), 'archive/fBH3JoQDjZegNio4gYH99hTDS872')
    var notifications = []
    for(var app of apps) {
      var notiQuery = query(reference, orderByChild('app'), equalTo(app), sorter === 'Newest' ? limitToLast(3) : limitToFirst(3))
      var snapshot = await get(notiQuery)
      if(snapshot.exists()) {
        snapshot.forEach(function(snap){
          var n = snap.val()
          if (!inBlacklist(n)) {
            var url = getDownloadURL(storageRef(storage, n.app + '.jpg')).then((url) => {
              n['icon'] = url
              n['title'] = cleanTitle(n)
              n['date'] = timeSince(n.id)

              notifications.push(n)
              notifications.sort(function (a, b) {
                return b.id > a.id ? 1 : -1
              })
              setNotificationList(notifications.map((item) => {
                return (
                  <LiveCampaignItem
                    key={item.id}
                    id={item.id}
                    image={item.icon}
                    app={item.appName}
                    link={item.id}
                    title={item.title}
                    text={item.extraText}
                    date={item.date}
                    type={item.appName}
                    fav={item.id}
                  />
                );
              }))

            }).catch((error) => {
              n['icon'] = MissingIcon
              n['title'] = cleanTitle(n)
              n['date'] = timeSince(n.id)

              notifications.push(n)
              notifications.sort(function (a, b) {
                return b.id > a.id ? 1 : -1
              })
              setNotificationList(notifications.map((item) => {
                return (
                  <LiveCampaignItem
                    key={item.id}
                    id={item.id}
                    image={item.icon}
                    app={item.appName}
                    link={item.id}
                    title={item.title}
                    text={item.extraText}
                    date={item.date}
                    type={item.appName}
                    fav={item.id}
                  />
                );
              }))
            });
          }
        });
        setLoadingVisible(false)
      }
      if(notifications.length>50)
        break
    }
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">

      <Helmet>
        <title>EmPushy | Live Campaigns</title>
      </Helmet>

      {/* Page header */}
      <div className="sm:flex sm:justify-between sm:items-center mb-5">

        {/* Left: Title */}
        <div className="mb-4 sm:mb-0">
          <ul className="inline-flex flex-wrap text-sm font-medium">
            <li className="flex items-center">
              <div className="text-slate-500 hover:text-pink-500 cursor-pointer"
                   onClick={()=>updateContentState('home')}>Home</div>
              <svg className="h-4 w-4 fill-current text-slate-400 mx-3" viewBox="0 0 16 16">
                <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
              </svg>
            </li>
            <li className="flex items-center">
              <a className="text-slate-500">Live Campaigns</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-col space-y-10 sm:flex-row sm:space-x-6 sm:space-y-0 md:flex-col md:space-x-0 md:space-y-10 xl:flex-row xl:space-x-6 xl:space-y-0 mt-9">

        {/* Sidebar */}
        <LiveCampaignsSidebar setAlertModalState={setAlertModalState} audienceTypes={Object.keys(metaAudience)}
                              brandSizes={Object.keys(metaBrandSize)} updateFilter={updateFilter}/>

        {/* Content */}
        <div className='w-full'>

          <div className="mb-8">
            <div className="grid grid-cols-9 gap-8 place-content-center">
              <LiveCampaignStatCard name="Brands Tracked" stat={brandCount} icon="👀"/>
              <LiveCampaignStatCard name="Campaigns Logged" stat={campaignCount} icon="🔔"/>
              <LiveCampaignStatCard name="Different Markets" stat={marketCount} icon="⚖️"/>
            </div>
          </div>
          {/* Stats cards*/}

          {/* Search form */}
          <div className="mb-5">
            <form className="relative" onSubmit={textFilterChange}>
              <label htmlFor="noti-search" className="sr-only">Search</label>
              <input id="noti-search" className="form-input w-full pl-9 focus:border-pink-300 shadow-1" type="search" maxLength="40"
                     placeholder="Search notification title or keyword…" />
              <button className="absolute inset-0 right-auto group" type="submit" aria-label="Search" onClick={textFilterChange}>
                <svg className="w-4 h-4 shrink-0 fill-current text-pink-400 group-hover:text-pink-500 ml-3 mr-2" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
                  <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
                </svg>
              </button>
            </form>
          </div>

          {/* Jobs header */}
          <div className="flex justify-between items-center mb-4">
            <div className="text-sm text-slate-500 italic">Showing {notificationList.length} notifications</div>
            {/* Sort */}
            <div className="text-sm">
              <span>Sort by </span>
              <DropdownSort align="right" updateFunc={updateSorter} />
            </div>
          </div>

          {/* Jobs list */}
          <div className='space-y-2'>
            {
              loadingVisible?
                <div className="sm:flex justify-items-center mt-5 w-full">
                  <div className="m-auto">
                    <svg className="animate-spin h-8 w-8" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="10" fill="transparent" strokeLinecap="round"
                              strokeDasharray="283" strokeDashoffset="75"/>
                    </svg>
                  </div>
                </div>:
              notificationList!=''?notificationList:'No live stream. Check back later or select different filters.'
            }
          </div>
          <div className="mt-6 w-full text-center">
            <button
              className="btn bg-white border-gray-200 hover:border-gray-300 text-gray-500 hover:text-gray-600"
              onClick={() =>
                setAlertModalState({title: 'Contact Us ✉', message: 'To access this feature and others which facilitate greater ' +
                    'in-depth analysis, please send us an email (hello@empushy.com) and we will add you to our exclusive beta group.'})
              }>
              Load more
            </button>
          </div>
          {/* Pagination */}
          {/*<div className="mt-6">
                    <PaginationNumeric />
                  </div>*/}

        </div>

      </div>

    </div>
  );
}

export default LiveCampaignsContent;